import React, { useEffect } from 'react';
import Header from  './components/Header';
import About from './components/About';
import Resume from './components/Resume';
import Projects from './components/Projects';
import Contact from './components/Contact';
import './App.css';

export const AppContext = React.createContext();

function App() {
  const contextStates = {
  
  }

  useEffect(() => {
    const sections = document.querySelectorAll('section')
    const navLi = document.querySelectorAll('#navbar-container #navbar-links li')

    window.addEventListener('scroll', () => {
      let current = ''
      sections.forEach(section => {
        const sectionTop = section.offsetTop
        // const sectionHeight = section.clientHeight
        if (window.scrollY >= sectionTop - 100) {
          current = section.getAttribute('id')
        }
      })

      navLi.forEach(a => {
        a.classList.remove('active')
        if (a.classList.contains(current)) {
          a.classList.add('active')
        }
      })
    })
  })

  return (
    <div className="App">
      <AppContext.Provider value={contextStates}>
        <Header />
        <About />
        <Resume />
        <Projects />
        <Contact />
      </AppContext.Provider>
    </div>
  );
}

export default App;
